import { humanize } from 'underscore.string';
import { Metadata } from 'src/constants/types';

export default function getTagPageSeo(tag: string, resultsNumber: number): Metadata {
  const tagName = humanize(tag);

  // Title should not exceeding 65 characters
  const charsForHu = ' | HealthUnlocked'.length;
  const charsForTitle = 65 - charsForHu;
  const title = `Experiences with ${tagName}`;
  const titleSnippet = title.length > charsForTitle
    ? title.substring(0, charsForTitle - 3).trimRight() + '...'
    : title;

  const shouldIndexPage = () => (resultsNumber > 0);

  return {
    canonical: `https://healthunlocked.com/tag/${tag}`,
    title: `${titleSnippet} | HealthUnlocked`,
    description: `Read posts from people who have experience with ${tagName}. Find communities that can answer your questions and offer insights.`,
    robots: shouldIndexPage() ? '' : 'noindex, nofollow',
  };
}
